import React from "react";

const WhatsAppFloat = () => (
  <a
    href="https://wa.me/355682222286?text=Pershendetje%20Brothers%20Taxi%21%20Doja%20te%20rezervoja%20nje%20taxi."
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float-button"
    aria-label="WhatsApp Brothers Taxi"
    className="fixed bottom-20 right-5 md:bottom-6 md:right-6 z-40 h-14 w-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-2xl shadow-black/50 animate-pulse-yellow hover:scale-110 transition-transform"
  >
    <svg viewBox="0 0 32 32" className="h-7 w-7 fill-white" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39-.158 0-.346-.078-.534-.158-1.382-.553-3.236-2.376-3.748-3.752-.079-.215-.115-.401-.115-.553 0-.401 1.388-.998 1.388-1.391 0-.085-.038-.158-.072-.215-.265-.561-.713-1.611-1.082-2.276-.143-.255-.395-.398-.692-.398-.317 0-.598.072-.853.215-1.382.756-1.84 1.842-1.84 3.34 0 .553.122 1.123.336 1.711.673 1.844 3.027 5.117 6.43 6.512 1.382.572 2.394.751 3.135.751 1.18 0 2.179-.401 2.834-1.043.49-.48.766-1.158.766-1.844 0-.215-.072-.401-.143-.553-.336-.756-2.276-1.762-2.292-1.762zM16.001 0c8.84 0 16 7.16 16 16s-7.16 16-16 16c-2.834 0-5.501-.756-7.808-2.083l-9.119 2.397 2.435-8.881C.522 21.183 0 18.668 0 16 0 7.16 7.161 0 16.001 0zm0 30.001c7.738 0 14-6.262 14-14s-6.262-14-14-14-14 6.262-14 14c0 2.737.788 5.317 2.148 7.469l-1.395 5.094 5.254-1.376C10.752 28.987 13.31 30 16.001 30z"/>
    </svg>
  </a>
);

export default WhatsAppFloat;
